var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTowerObstructionLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2078,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2474,
    y: 8,
    width: 2079,
    height: 2078
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3049,
    y: 588,
    width: 933,
    height: 935
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3049,
    y: 588,
    width: 933,
    height: 935
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3049,
    y: 588,
    width: 933,
    height: 935
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2474 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2474,
    y: 7.9999,
    width: 2079,
    height: 2078,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2728,
    y: 262,
    width: 1571,
    height: 1570,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2883 1047C2883 699.061 3165.28 417 3513.5 417 3861.72 417 4144 699.061 4144 1047 4144 1394.94 3861.72 1677 3513.5 1677 3165.28 1677 2883 1394.94 2883 1047Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.544 205.066 727.934 122.456 466.5 383.891 205.066 122.456 122.456 205.066 383.891 466.5 122.456 727.934 205.066 810.544 466.5 549.109 727.934 810.544 810.544 727.934 549.109 466.5Z",
    fill: "#222222",
    transform: "matrix(1 0 0 1 3049 589)"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerObstructionLight);
export default __webpack_public_path__ + "static/media/TowerObstructionLight.e570791de30dc3facb5e4dfbcb88e708.svg";
export { ForwardRef as ReactComponent };